import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Text,
  Icon,
  Grid,
  GridItem,
  Link,
  Spacer,
} from "@chakra-ui/react";
import styles from "./styles/Card.module.css";
import { ReactComponent as Time } from "../../img/icons/time.svg";
import { LinkContext } from "../../LinkContext";

interface EventType {
  id: number;
  slug: string;
  title: string;
}
export interface Event {
    id: number;
    type: EventType;
    date_readable: string;
    day_of_week: string | null;
    end_at_readable: string | null;
    time_readable: string | null;
    duration: number;
    title: string;
    is_online: number;
    places: number;
    places_vacant: number;
}

const Card = ({ event }: { event: Event }) => {
  const {
    type: eventType,
    date_readable: dateReadable,
    day_of_week: dayOfWeek,
    end_at_readable: endDateReadable,
    time_readable: timeReadable,
    duration,
    id,
    title,
    is_online: isOnline,
    places,
    places_vacant: placesVacant,
  } = event;

  const colors: { [key: number]: string } = {
    1: "#1C8975",
    2: "#1C5B89",
    3: "#381C89",
    12: "#989B8D",
    15: "#891C57",
    21: "#E48F0D",
    25: "#03B575",
    26: "#895D1C",
    28: "#38891C",
  };

  const icons: { [key: number]: string } = {
    1: `${styles.masterClass}`,
    2: `${styles.lecture}`,
    3: `${styles.excursion}`,
    12: `${styles.presentation}`,
    15: `${styles.diu}`,
    21: `${styles.meeting}`,
    25: `${styles.lecture}`,
    26: `${styles.intensive}`,
    28: `${styles.diu}`,
  };

  function getDeclension(num: number, one: string, few: string, many: string) {
    if (num % 10 === 1 && num % 100 !== 11) {
      return one;
    } else if (
      num % 10 >= 2 &&
      num % 10 <= 4 &&
      (num % 100 < 10 || num % 100 >= 20)
    ) {
      return few;
    } else {
      return many;
    }
  }

  function durationReadable(time: number) {
    var hours = Math.floor(time / 60);
    var minutes = time % 60;

    var hoursString = hours
      ? hours + " " + getDeclension(hours, "час", "часа", "часов")
      : "";
    var minutesString = minutes
      ? minutes + " " + getDeclension(minutes, "минута", "минуты", "минут")
      : "";

    var readableTime = hoursString + " " + minutesString;

    return readableTime;
  }

  return (
    <Flex
      h="100%"
      borderRadius="8px"
      border={`1px solid ${colors[eventType.id]}`}
      bgImage='url("/ellipse.svg")'
      bgSize="contain"
      bgRepeat="no-repeat"
      backgroundPosition="right 10% bottom 5%"
    >
      <div
        className={styles.eventTypeTag}
        style={{ background: colors[eventType.id] }}
      >
        <div className={styles.verticalText}>{eventType.title}</div>
        <div className={icons[eventType.id]}></div>
      </div>
      <Grid 
        templateRows="50px 1fr 25px" 
        p="18px" 
        pl="35px" 
        gap="30px"
        w="100%"
      >
        <GridItem>
          <Flex w="100%" h="50px" alignItems="center">
            <Text as="b" fontSize="40px" color={colors[eventType.id]}>
              {dateReadable.split(" ")[0]}
            </Text>
            <Box ml="5px">
              <Text>{dateReadable.split(" ")[1]}</Text>
              {dayOfWeek && <Text color="gray.400">{dayOfWeek}</Text>}
            </Box>
            {endDateReadable && (
              <>
                <div className={styles.rect}></div>
                <Text as="b" fontSize="40px" color={colors[eventType.id]}>
                  {endDateReadable.split(" ")[0]}
                </Text>
                <Box ml="5px">
                  <Text>{endDateReadable.split(" ")[1]}</Text>
                </Box>
              </>
            )}
            {timeReadable && (
              <>
                <Spacer />
                <Icon as={Time} h="30px" w="30px" />
                <Box ml="5px">
                  <Text>{timeReadable}</Text>
                  <Text color="gray.400">{durationReadable(duration)}</Text>
                </Box>
              </>
            )}
          </Flex>
        </GridItem>
        <GridItem>
          <LinkContext.Consumer>
            {(APP_LINK) => (
              <Text fontSize="23px" as="b">
                <Link href={`${APP_LINK}/event?event_id=${id}`} target="_blank">
                  {title}
                </Link>
              </Text>
            )}
          </LinkContext.Consumer>
        </GridItem>
        <GridItem>
          <Text as="b" fontSize="18px" color={isOnline ? "#03B575" : "#EA0029"}>
            {isOnline
              ? "#Онлайн"
              : `#Очно ${places - placesVacant}/${places} чел`}
          </Text>
        </GridItem>
      </Grid>
    </Flex>
  );
};

export default Card;
